import React from "react";
import CorpAdmin from "../../images/CorperateAdmin.png";

export default function FutureCorpAdmin() {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <img
        style={{ padding: 5 }}
        height={"100%"}
        width={"100%"}
        src={CorpAdmin}
      />
    </div>
  );
}
